import {
  PreScreeningQuestion,
  QuestionType,
} from "../../types/landingPage";
import { mappers } from "../../utils/attributeMapping/mappers";
import { azAppreciateScreeningQuestions } from "./AZAppreciateScreener";

/**
 * Flow C variant of AZ Appreciate screener
 * Splits the single insulin experience question (Q9) into two sequential questions:
 * 1. Are you currently using insulin?
 * 2. Have you ever used insulin long-term (>3 months)?
 */

const diabetesQuestionWithUpdatedSkip: PreScreeningQuestion = {
  ...azAppreciateScreeningQuestions[7], // diabetes question (index 7)
  options: azAppreciateScreeningQuestions[7].options!.map((option) =>
    option.value === "no_diabetes"
      ? { ...option, skipNextQuestions: 2 } // Skip both insulin questions
      : option
  ),
};

const currentInsulinQuestion: PreScreeningQuestion = {
  id: "current_insulin_use",
  type: QuestionType.RADIO,
  question: "Are you currently using insulin to manage your diabetes?",
  helpText:
    "Insulin is usually taken as an injection, pen or through an insulin pump (for example Humalog, Lantus, NovoLog, or Levemir).",
  required: true,
  allowBack: true,
  options: [
    {
      value: "yes",
      label: "Yes",
      disqualify: true,
    },
    {
      value: "no",
      label: "No",
    },
  ],
  disqualifyMessage:
    "This study cannot include people who are currently using insulin.",
  attributeMapping: mappers.value({
    yes: [
      { attributeDefinitionId: 23574, booleanAttributeValue: true }, // has_insulin_daily
    ],
    no: [
      { attributeDefinitionId: 23574, booleanAttributeValue: false }, // has_insulin_daily
    ],
  }),
};

const pastInsulinQuestion: PreScreeningQuestion = {
  id: "past_insulin_longterm",
  type: QuestionType.RADIO,
  question:
    "Have you ever used insulin long-term (for more than 3 months at a time) to manage your diabetes?",
  required: true,
  allowBack: true,
  options: [
    {
      value: "yes",
      label: "Yes",
      disqualify: true,
    },
    {
      value: "no",
      label: "No",
    },
  ],
  disqualifyMessage:
    "This study cannot include people who have used insulin long-term.",
  attributeMapping: mappers.value({
    yes: [
      { attributeDefinitionId: 26773, booleanAttributeValue: false }, // insulin_less_than_3_months - no, used 3+ months
    ],
    no: [
      { attributeDefinitionId: 26773, booleanAttributeValue: true }, // insulin_less_than_3_months - yes, never used 3+ months
    ],
  }),
};

export const azAppreciateFlowCScreeningQuestions: PreScreeningQuestion[] = [
  ...azAppreciateScreeningQuestions.slice(0, 7), // Q1-Q7 unchanged (indices 0-6)
  diabetesQuestionWithUpdatedSkip, // Q8: diabetes with skipNextQuestions: 2
  currentInsulinQuestion, // Q9: currently using insulin?
  pastInsulinQuestion, // Q10: ever used insulin long-term?
  ...azAppreciateScreeningQuestions.slice(9), // Q11 onwards unchanged (skips original insulin_experience at index 8)
];
